import { useContext, useEffect, useState } from "react"
import { useForm, FormProvider, useFormContext } from "react-hook-form"
import * as yup from "yup"
import { yupResolver } from "@hookform/resolvers/yup"
import intl from "react-intl-universal"

import Button from "../../atoms/Button"
import Input from "../../atoms/Input"
import Label from "../../atoms/Label"
import Modal from "../../molecules/Modal"
import styles from "./index.module.scss"
import Tabs from "../../molecules/Tabs"
import PurePlusIcon from "../../../assets/icons/PurePlusIcon"
import MoveIcon from "../../../assets/icons/MoveIcon"
import TrashIcon from "../../../assets/icons/TrashIcon"
import EditIcon from "../../../assets/icons/EditIcon"
import ClipIcon from "../../../assets/icons/ClipIcon"
import CommnetDotsIcon from "../../../assets/icons/CommnetDotsIcon"
import ClockRotateIcon from "../../../assets/icons/ClockRotateIcon"
import RcmpActivityEvidence from "./ActivityEvidence"
import {
  fnFormatDate,
  fnFormatDateToUTC,
  fnFormatDateFromDate,
} from "../../../utils/date"
import EvidenceTextCard from "../../atoms/EvidenceTextCard"
import AuthContext from "../../../contexts/Auth"
import RcmpModalEditComment from "../../molecules/ModalEditComment"
import ModalConfirmDelete from "../ModalAddPainelCancel"
import RcmpActivityField from "../ActivityField"
import RcmpActivityHistory from "./ActivityHistory"
import {
  cDeadLineSlug,
  cDescritionSlug,
  cResponsiblesSlug,
  dCreationDateSlug,
  cStatusSlug,
  cTitleSlug,
  dConclusionDateSlug,
  cInvolvedsSlug,
} from "../../../constans/activity-slugs"
import RcmpAlert from "../../atoms/Alert"
import FieldsContext from "../../../contexts/Fields"
import PaineisContext from "../../../contexts/Paineis"
import BoardContext from "../../../contexts/Board"
import useCheckSubmitRegister from "../../../hooks/useCheckSubmitRegister"
import RcmpModalInfo from "../ModalInfo"
import RcmpLoading from "../../atoms/Loading"
import { isEqual } from "../../../utils/compare"
import { BlocksContext } from "../../../contexts/Blocks"

const cPrefixFieldName = "activity-field-"

function fnCreateFieldsValitionSchema(aFields, bIsEdit, cUserTimeZone, bCurrentStatus, aAllFields) {
 
  if (!aFields?.length) return
  //validação do responsável
  const bValidateResponsible = aFields.some(
    (field) => field.opfd_cslug === cResponsiblesSlug,
  )

  // Find field id
  const responsibleField = aFields.find((field) => field.opfd_cslug === cResponsiblesSlug)

  const nFieldId = responsibleField?.ombf_opfd_nid
    ? responsibleField?.ombf_opfd_nid
    : responsibleField?.opfd_nid
  const cFieldName = `${cPrefixFieldName}${nFieldId}`
  

  let responsibleSchema = yup
    .array()
    .of(yup.number())
    .transform((curr, orig) => {
      return orig
    })

  if (bValidateResponsible) {
    responsibleSchema = responsibleSchema
      .min(1, intl.get("form.select_responsibles"))
      .required(intl.get("form.select_responsibles"))
  }

  let fieldsValidations = {}
  fieldsValidations[cFieldName] = responsibleSchema

  // Check if status is Done

  aFields?.map((field) => {
    const nFieldId = field?.ombf_opfd_nid ? field?.ombf_opfd_nid : field?.opfd_nid
    const cFieldName = `${cPrefixFieldName}${nFieldId}`
    const bIsRequiredToCreate =
      field?.ombf_brequired === "TO_CREATE" && !field?.ombf_bautofill
    const bIsRequiredToComplete =
      field?.ombf_brequired === "TO_CONCLUDE" && bIsEdit && !field?.ombf_bautofill

    let bIsRequired = bIsRequiredToCreate
    if (bIsEdit && bCurrentStatus) {
      bIsRequired = bIsRequiredToComplete
    }

    // deadline validation
    if (field?.opfd_cslug === cDeadLineSlug) {
      // no min date on edit activity

      if (bIsEdit) {
        return (fieldsValidations[cFieldName] = bIsRequired
          ? yup
              .date()
              .nullable()
              .transform((curr, orig) => {
                if (!orig || orig?.length == 0) {
                  return null
                } else {
                  return new Date(
                    fnFormatDateToUTC(orig, cUserTimeZone, "YYYY-MM-DD[T]HH:mm:ss.SSS"),
                  )
                }
              })
              .required(intl.get("form.required_field"))
              .typeError(intl.get("form.invalid_date"))
          : yup
              .date()
              .nullable()
              .transform((curr, orig) => {
                if (!orig || orig?.length == 0) {
                  return null
                } else {
                  return new Date(
                    fnFormatDateToUTC(orig, cUserTimeZone, "YYYY-MM-DD[T]HH:mm:ss.SSS"),
                  )
                }
              })
              .typeError(intl.get("form.invalid_date")))
      }

      const dYesterday = new Date()

      return (fieldsValidations[cFieldName] = bIsRequired
        ? yup
            .date()
            .nullable()
            .transform((curr, orig) => {
              if (!orig || orig?.length == 0) {
                return null
              } else {
                return new Date(
                  fnFormatDateToUTC(orig, cUserTimeZone, "YYYY-MM-DD[T]HH:mm:ss.SSS"),
                )
              }
            })
            .min(dYesterday, intl.get("form.min_date_today"))
            .required(intl.get("form.required_field"))
            .typeError(intl.get("form.invalid_date"))
        : yup
            .date()
            .nullable()
            .transform((curr, orig) => {
              if (!orig || orig?.length == 0) {
                return null
              } else {
                return new Date(
                  fnFormatDateToUTC(orig, cUserTimeZone, "YYYY-MM-DD[T]HH:mm:ss.SSS"),
                )
              }
            })
            .min(dYesterday, intl.get("form.min_date_today"))
            .typeError(intl.get("form.invalid_date")))
    }

    //  conclusion date validation
    if (field?.opfd_cslug === dCreationDateSlug) {
      if (!bIsEdit) return
      return (fieldsValidations[cFieldName] = yup
        .date()
        .nullable()
        .transform((curr, orig) => {
          if (!orig || orig?.length == 0) {
            return null
          } else {
            return new Date(
              fnFormatDateToUTC(orig, cUserTimeZone, "YYYY-MM-DD[T]HH:mm:ss.SSS"),
            )
          }
        })
        .typeError(intl.get("form.invalid_date")))
    }

    if (field?.opfd_cslug === dConclusionDateSlug) {
      return (fieldsValidations[cFieldName] = bIsRequired
        ? yup
            .date()
            .nullable()
            .transform((curr, orig) => {
              if (!orig || orig?.length == 0) {
                return null
              } else {
                return new Date(
                  fnFormatDateToUTC(orig, cUserTimeZone, "YYYY-MM-DD[T]HH:mm:ss.SSS"),
                )
              }
            })
            .required(intl.get("form.required_field"))
            .typeError(intl.get("form.invalid_date"))
        : yup
            .date()
            .nullable()
            .transform((curr, orig) => {
              if (!orig || orig?.length == 0) {
                return null
              } else {
                return new Date(
                  fnFormatDateToUTC(orig, cUserTimeZone, "YYYY-MM-DD[T]HH:mm:ss.SSS"),
                )
              }
            })
            .typeError(intl.get("form.invalid_date")))
    }

    if (field?.opfd_cslug === cStatusSlug) {
      return yup.string()
    }

    if (field?.opfd_ctype?.toLowerCase() === "date") {
      return (fieldsValidations[cFieldName] = bIsRequired
        ? yup
            .date()
            .nullable()
            .transform((curr, orig) => {
              if (!orig || orig?.length == 0) {
                return null
              } else {
                return new Date(
                  fnFormatDateToUTC(orig, cUserTimeZone, "YYYY-MM-DD[T]HH:mm:ss.SSS"),
                )
              }
            })
            .required(intl.get("form.required_field"))
            .typeError(intl.get("form.invalid_date"))
        : yup
            .date()
            .nullable()
            .transform((curr, orig) => {
              if (!orig || orig?.length == 0) {
                return null
              } else {
                return new Date(
                  fnFormatDateToUTC(orig, cUserTimeZone, "YYYY-MM-DD[T]HH:mm:ss.SSS"),
                )
              }
            })
            .typeError(intl.get("form.invalid_date")))
    }

    if (field?.opfd_ctype?.toLowerCase() === "peoples") {
      return (fieldsValidations[cFieldName] = bIsRequired
        ? yup
            .array()
            .transform((curr, orig) => {
              return orig
            })
            .min(1, intl.get("form.required_field"))
            .of(yup.number())
            .required(intl.get("form.required_field"))
            .typeError(intl.get("form.invalid_date"))
        : yup.array().notRequired())
    }

    if (field?.opfd_ctype?.toLowerCase() === "selection") {
      return (fieldsValidations[cFieldName] = bIsRequired
        ? yup.mixed().required(intl.get("form.required_field"))
        : yup.mixed().nullable())
    }

    if (field?.opfd_ctype?.toLowerCase() === "calc") {
      
      return (fieldsValidations[cFieldName] = bIsRequired
        ? yup.mixed().required(intl.get("form.required_field"))
        : yup.mixed().nullable())
    }
    if (field?.opfd_ctype?.toLowerCase() === "range") {

      const currField = aAllFields.find((f) => f.opfd_nid === field.ombf_opfd_nid) || field
      const minLimit = Number(currField?.opfd_nmin_limit.replace(',', '.'))
      const maxLimit = Number(currField?.opfd_nmax_limit.replace(',', '.'))

      return (fieldsValidations[cFieldName] = bIsRequired
        ? yup
        .string()
        .test({
          test: (value) => {
            let currValue = Number(value?.replace(',', '.'))
            if (isNaN(currValue)) {
              return false
            }
            if (currValue < minLimit || currValue > maxLimit) {
              return false
            }
            
            return true
          },
          message: ""
        })
        .required(intl.get("form.required_field"))
        
        : yup.string()
        .default("")
        .test({
          test: (value) => {
            let currValue = Number(value?.replace(',', '.'))
            if (!value) {
              return true
            }
            if (isNaN(currValue)) {
              return false
            }
            if (currValue < minLimit || currValue > maxLimit) {
              return false
            }
            
            return true
          },
          message: ""
        })
        .nullable())
      
    }
    return (fieldsValidations[cFieldName] = bIsRequired
      ? yup.string().default("").required(intl.get("form.required_field"))
      : yup.string().default(""))
  })

  return yup.object().shape(fieldsValidations)
}
function fnGetDinamycFields(fields, allFields) {
  if (!fields) return
  const aFilteredFields = Object.keys(fields)?.filter((cFieldName) => {
    const cField = cFieldName?.startsWith(cPrefixFieldName)
    const nFieldId = Number(cFieldName?.replace(/\D/g, ""))

    if (cField && !fields?.arr_nfields_to_delete?.includes(nFieldId)) return cFieldName
  })

  return aFilteredFields?.map((cFieldName, i) => {
    const nFieldId = Number(cFieldName?.replace(/\D/g, ""))

    let oField = allFields?.find(
      (roField) => roField?.opfd_nid === nFieldId || roField?.ombf_opfd_nid === nFieldId,
    )
    const nFieldIndex = allFields?.findIndex(
      (roField) => roField?.opfd_nid === nFieldId || roField?.ombf_opfd_nid === nFieldId,
    )
    const bIsSelection = oField?.opfd_ctype === "SELECTION"
    const bIsPeople = oField?.opfd_ctype === "PEOPLES"
    const bIsDate = oField?.opfd_ctype === "DATE"
    const bIsCalc = oField?.opfd_ctype === "CALC"
    const bIsRange = oField?.opfd_ctype === "RANGE"
    if (bIsSelection && typeof fields[cFieldName] === "object") {
      oField = oField.opfv_opfs_nid
    }
    if (bIsDate) {
      if (Array.isArray(fields[cFieldName])) {
        return {
          opfd_nid: nFieldId,
          opfv_cvalue:
            fnFormatDateFromDate(fields[cFieldName][0], "YYYY-MM-DD[T]HH:mm:ss.SSS") ||
            "",
          nposition: nFieldIndex,
        }
      } else {
        return {
          opfd_nid: nFieldId,
          opfv_cvalue:
            fnFormatDateFromDate(fields[cFieldName], "YYYY-MM-DD[T]HH:mm:ss.SSS") || "",
          nposition: nFieldIndex,
        }
      }
    }
    if (bIsCalc) {
      return {
        opfd_nid: nFieldId,
        opfv_cvalue: fields[cFieldName].value || "",
        opfv_cformula: fields[cFieldName].formula || "",
        nposition: nFieldIndex,
      }
    }
    if (bIsRange) {
      return {
        opfd_nid: nFieldId,
        opfv_cvalue: fields[cFieldName] || "",
        nposition: nFieldIndex,
        min_limit: oField?.opfd_nmin_limit,
        max_limit: oField?.opfd_nmax_limit,
        min_ideal: oField?.opfd_nmin_ideal,
        max_ideal: oField?.opfd_nmax_ideal,
      }
    }
    if (oField?.opfd_cslug === cDescritionSlug) {
      return {
        opfd_nid: nFieldId,
        nposition: nFieldIndex,
        opfv_cvalue: fields[cFieldName] || "",
      }
    }
    const oValue = bIsSelection
      ? {
          opfv_opfs_nid:
            typeof fields[cFieldName] === "object"
              ? fields[cFieldName]?.value
              : fields[cFieldName] || null,
        }
      : bIsPeople
      ? { peoples: fields[cFieldName] || [], nposition: nFieldIndex }
      : {
          opfv_cvalue:
            typeof fields[cFieldName] === "object"
              ? fields[cFieldName]?.value
              : fields[cFieldName] || "",
          nposition: nFieldIndex,
        }

    return {
      opfd_nid: nFieldId,
      nposition: nFieldIndex,
      ...oValue,
    }
  })
}
function RcmpEditActivity(props) {
  const {
    fnOpenModalMoveActivity,
    bIsEdit,
    oCurrentActivity,
    fnSetBIsDeleteActivity,
    fnSetCurrentStatus,
    fnSetBopenCustomFields,
    bCanChange,
    bReadOnly,
    oActivityFields,
    nActivityId,
    bIsAutomationList,
  } = props
  const useFormMethods = useFormContext()
  const {
    setValue,
    getValues,
  } = useFormMethods

  function fnSetResponsibles(aResponsibles, nFieldId, defaultValue) {
    if (!aResponsibles?.length) {
      setValue("responsibles", [])
      setValue(`activity-field-${nFieldId}`, [])
      return
    }
    const bIsDirty = isEqual(defaultValue, aResponsibles)

    setValue(
      "responsibles",
      aResponsibles?.map((v) => v.value),
      {
        shouldDirty: !bIsDirty,
      },
    )
    setValue(
      `activity-field-${nFieldId}`,
      aResponsibles?.map((v) => v.value),
      { shouldDirty: !bIsDirty },
    )
  }

  function fnSetInvolveds(aInvolveds, nFieldId, defaultValue) {
    if (!aInvolveds?.length) {
      setValue("involveds", [])
      setValue(`activity-field-${nFieldId}`, [])
      return
    }

    const bIsDirty = isEqual(aInvolveds, defaultValue)
    setValue(
      "involveds",
      aInvolveds?.map((v) => v.value),
      { shouldDirty: !bIsDirty },
    )
    setValue(
      `activity-field-${nFieldId}`,
      aInvolveds?.map((v) => v.value),
      { shouldDirty: !bIsDirty },
    )
  }

  useEffect(() => {
    // Run change status to parent
    fnSetCurrentStatus(getValues()?.status === "Done")
  }, [getValues()])

  const aResponsibles = oCurrentActivity?.responsibles?.length
    ? oCurrentActivity?.responsibles?.map((r) => ({
        value: r?.user_nid,
        label: r?.user_cname,
      }))
    : []

  const aInvolveds = oCurrentActivity?.involveds?.length
    ? oCurrentActivity?.involveds?.map((r) => ({
        value: r?.user_nid,
        label: r?.user_cname,
      }))
    : []

  if (bIsEdit && !oActivityFields[0]?.values?.length) {
    return <RcmpLoading bShow={true} />
  }

  return (
    <div className={styles.fieldsContainer}>
      <div className={styles.buttonsContainer}>
        {!bIsAutomationList && bCanChange && (
          <button type="button" onClick={fnSetBopenCustomFields}>
            <PurePlusIcon /> {intl.get("BlocksPage.add_fields")}
          </button>
        )}
        {(bIsEdit && (!bReadOnly || bCanChange)) && (
          <>
            {!bIsAutomationList && (
              <button type="button" onClick={fnOpenModalMoveActivity}>
                <MoveIcon /> {intl.get("BlocksPage.move_activity")}
              </button>
            )}
            <button
              type="button"
              onClick={() => fnSetBIsDeleteActivity(true)}
              className={styles.delete}
            >
              <TrashIcon /> {intl.get("BlocksPage.delete_activity")}
            </button>
          </>
        )}
      </div>
      {bIsEdit && (
        <>
          <div className={styles.idContainer}>
            <Input
              disabled
              value={nActivityId}
              label={intl.get("BlocksPage.activity_id")}
              isFullWidth
            />
          </div>
        </>
      )}
      {oActivityFields?.map((field) => {
        let cLabel = field.opfd_cname
        const nFieldId = bIsEdit ? field.opfd_nid : field?.ombf_opfd_nid
        switch (field.ombf_brequired) {
          case "NOT_REQUIRED":
            cLabel = (
              <div className={styles.requiredTextContainer}>
                <p className={styles.fieldName}>{`${field.opfd_cname}`} </p>
                <p className={styles.requiredText}>
                  ({intl.get("BlocksPage.form.not_required_field")}){" "}
                </p>
              </div>
            )
            break
          case "TO_CREATE":
            cLabel = (
              <div className={styles.requiredTextContainer}>
                <p className={styles.fieldName}>{`${field.opfd_cname}`} </p>
                <p className={styles.requiredText}>
                  ({intl.get("BlocksPage.form.required_to_criation")}){" "}
                </p>
              </div>
            )
            break
          case "TO_CONCLUDE":
            cLabel = (
              <div className={styles.requiredTextContainer}>
                <p className={styles.fieldName}>{`${field.opfd_cname}`} </p>
                <p className={styles.requiredText}>
                  ({intl.get("BlocksPage.form.required_to_conclusion")}){" "}
                </p>
              </div>
            )
            break
        }

        if (field.opfd_cslug === cInvolvedsSlug) {
          return (
            <div className={styles.fieldContainer} key={nFieldId} tabIndex={-1}>
              <RcmpActivityField
                opfd_nid={field?.ombf_opfd_nid || field?.opfd_nid}
                ombf_bautofill={field?.ombf_bautofill}
                defaultValue={aInvolveds}
                bIsEdit={bIsEdit}
                label={cLabel}
                onSelect={(e) => fnSetInvolveds(e, nFieldId, aInvolveds)}
                oCurrentActivity={oCurrentActivity}
                {...field}
              />
            </div>
          )
        }
        if (field.opfd_cslug === cResponsiblesSlug) {
          return (
            <div className={styles.fieldContainer} key={nFieldId} tabIndex={-1}>
              <RcmpActivityField
                opfd_nid={field?.ombf_opfd_nid || field?.opfd_nid}
                ombf_bautofill={field?.ombf_bautofill}
                defaultValue={aResponsibles}
                bIsEdit={bIsEdit}
                label={cLabel}
                onSelect={(e) => fnSetResponsibles(e, nFieldId, aResponsibles)}
                oCurrentActivity={oCurrentActivity}
                {...field}
              />
            </div>
          )
        }

        return (
          <div className={styles.fieldContainer} key={nFieldId} tabIndex={-1}>
            <RcmpActivityField
              label={cLabel}
              opfd_nid={field?.ombf_opfd_nid || field?.opfd_nid}
              ombf_bautofill={field?.ombf_bautofill}
              {...field}
              bIsEdit={bIsEdit}
              oCurrentActivity={oCurrentActivity}
              oActivityFields={oActivityFields}
            />
          </div>
        )
      })}
    </div>
  )
}
function RcmpActivityComments(props) {
  const {
    fnSubmitComment,
    fnDeleteComment,
    fnSubmitUpdateComment,
    aComments,
    fnSetAComments,
    bReadOnly,
    fnSetIsDirty,
    bIsCommentError,
    fnSetBIsCommentError,
  } = props
  const { oUser } = useContext(AuthContext)
  const cUserName = oUser?.data?.user_cname || ""
  const nUserId = oUser?.data?.user_nid || ""
  const schema = yup.object().shape({
    opacm_ccontent: yup.string(),
    cEditText: yup.string(),
  })
  const [bIsLoading, fnSetBIsLoading] = useState(false)

  function fnValidateComment(data) {
    if (!data) return true
    const contentWithoutSpaces = data.replace(/\s/g, "")
    return contentWithoutSpaces.length >= 2
  }

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    watch,
    formState: { errors, isDirty },
  } = useForm({
    resolver: yupResolver(schema),
    criteriaMode: "all",
  })

  async function fnSubmitEditComment(data) {
    await fnSUpdateComment(oOldComment.nCommentId, {
      opacm_ccontent: data.cEditText,
    })
    reset({
      opacm_ccontent: "",
      cEditText: "",
    })
    fnSetBEditComment(false)
  }

  const [bEditComment, fnSetBEditComment] = useState(false)
  const [oOldComment, fnSetOOldComment] = useState({})
  const [bDeleteComment, fnSetBdeleteComment] = useState(false)

  async function fnNewComment(data) {
    fnSetBIsCommentError?.(true)
    if (!data) return
    fnSetBIsLoading(true)
    const nCommentId = await fnSubmitComment(data)
    reset({ opacm_ccontent: "" })
    fnSetBIsLoading(false)

    if (!nCommentId || nCommentId < 0) return

    const bIsCommentValid = fnValidateComment(data.opacm_ccontent)
    if (!bIsCommentValid) {
      fnSetBIsCommentError?.(false)
      return
    }
    return fnSetAComments((prev) => [
      ...prev,
      {
        opae_cvalue: data.opacm_ccontent,
        cUserName: cUserName,
        dDate: fnFormatDate(new Date()),
        nUserId: nUserId,
        nCommentId: nCommentId?.data?.opacm_nid,
      },
    ])
  }
  function fnHandleEditComment(data) {
    fnSetOOldComment(data)
    fnSetBEditComment(true)
  }

  function fnHandleCancelEditComment() {
    fnSetBEditComment(false)
    fnSetOOldComment({})
  }
  function fnHandleDeleteComment(oComment) {
    fnSetOOldComment(oComment)
    fnSetBdeleteComment(true)
  }

  async function fnHandleCancelDeleteComment(oComment) {
    fnSetOOldComment({})  
    fnSetBdeleteComment(false)
  }
  function fnIsCommentAuthor(oComment) {
    return Boolean(oComment?.nUserId === nUserId)
  }

  async function fnSubmitDeleteComment() {
    if (oOldComment.nCommentId) {
      await fnDeleteComment(oOldComment.nCommentId)
      fnSetAComments((prev) => prev.slice(0, -1))
    }
    fnHandleCancelDeleteComment()
  }
  async function fnSUpdateComment(nCommentId, data) {
    fnSetBIsLoading(true)
    const response = await fnSubmitUpdateComment(nCommentId, data)
    fnSetAComments([])

    const commentsList = response.data.map((comment) => {
      return {
        opae_cvalue: comment.opacm_ccontent,
        cUserName: comment.user?.user_cname,
        dDate: comment.opacm_dcreated,
        nUserId: comment.user?.user_nid,
        nCommentId: comment.opacm_nid,
      }
    })
    fnSetAComments(commentsList.reverse())
    fnSetBIsLoading(false)

  }

  useEffect(() => {
    fnSetIsDirty(isDirty)
  }, [watch()])

  return (
    <div>
      {!bReadOnly && (
        <form id={"formNewComment"} onSubmit={handleSubmit(fnNewComment)}>
          <div className={styles.commentFieldContainer}>
            <div className={styles.rowDescription}>
              <Label>{intl.get("ActivityComments.insert_comment")}</Label>
              <textarea
                required
                className={styles.description}
                type="textarea"
                placeholder={intl.get("ActivityComments.comment_placeholder")}
                {...register("opacm_ccontent")}
              />
              {!bIsCommentError && (
                <span className={styles.error}>
                  {intl.get("ActivityComments.comment_error")}
                </span>
              )}
            </div>
            <Button
              type="submit"
              variant="outline"
              form={"formNewComment"}
              className={styles.submitCommentButton}
              isLoading={bIsLoading}
            >
              {intl.get("ActivityComments.sent_comment")}
            </Button>
          </div>
        </form>
      )}
      <div className={styles.commentsList}>
        <Label>{intl.get("ActivityComments.comments_sent")}</Label>
        {!aComments?.length ? (
          <div className={styles.notComments}>
            <p>{intl.get("ActivityComments.no_comments")}</p>
          </div>
        ) : (
          <div className={styles.evidencesComentsList}>
            {aComments
              .slice(0)
              .reverse()
              ?.map((comment, i) => {
                return (
                  <EvidenceTextCard
                    oData={comment}
                    key={i}
                    fnEditEvidence={fnHandleEditComment}
                    fnDeleteEvidence={fnHandleDeleteComment}
                    bShowActionButtons={
                      !bReadOnly && i === 0 && fnIsCommentAuthor(comment)
                    }
                  />
                )
              })}
          </div>
        )}
      </div>
      <RcmpModalEditComment
        bIsOpen={bEditComment}
        fnCancelEdit={fnHandleCancelEditComment}
        cOldValue={oOldComment?.opae_cvalue}
        fnHandleConfirm={fnSubmitEditComment}
        register={register}
        handleSubmit={handleSubmit}
        setValue={setValue}
        errors={errors}
        label={intl.get("ActivityComments.edit_comment")}
        bIsLoading={bIsLoading}
      />
      <ModalConfirmDelete
        fnOnClose={fnHandleCancelDeleteComment}
        isOpen={bDeleteComment}
        headerText={intl.get("ActivityComments.delete_comment")}
        bOnDelete={true}
        bHasPassword={false}
        idPainel={oOldComment?.opae_cvalue}
        text={intl.get("ActivityComments.confirm_delete_comment", {
          comment: oOldComment?.opae_cvalue,
        })}
        fnHandleDelete={fnSubmitDeleteComment}
      />
    </div>
  )
}

export default function RcmpModalAddActivity(props) {
  const {
    bIsOpen,
    bIsEdit,
    fnOnClose,
    fnOpenModalMoveActivity,
    fnCreateActivity,
    fnUpdateActivity,
    oActivityRes,
    oCurrentBlock,
    oCurrentActivity,
    fnSetBIsDeleteActivity,
    fnSetBopenCustomFields,
    bCanChange,
    fnSetBOpenModalMediaCapture,
    fnSetBOpenModalVideoCapture,
    fnSetOCurrentActivity,
    fnSubmitEvidence,
    fnSubmitComment,
    fnDeleteComment,
    oCreateCommentRes,
    fnSubmitUpdateComment,
    aCommentsList,
    aEvidences,
    fnSetAEvidences,
    bReadOnly,
    oSubmitEvidence,
    fnEditEvidenceSubmit,
    bIsAutomationList = false,
  } = props

  const { fnGetFields, oAllFieldsRes, aAllFields } = useContext(FieldsContext)
  const { oCurrentPanel } = useContext(PaineisContext)
  const { oCurrentBoard, oUpdateBoardModelRes } = useContext(BoardContext)
  const { fnSetOparams } = useContext(BlocksContext)

  const { oUser } = useContext(AuthContext)
  const cUserTimeZone = oUser?.data?.user_ctimezone

  const [aAcitivyFields, fnSetAActivityFields] = useState([])
  const [aActivityFieldsFormated, fnSetAAcitivyFieldsFormated] = useState([])
  const [aComments, fnSetAComments] = useState([])
  const [bCurrentStatus, fnSetCurrentStatus] = useState(false)
  const [nTabSelected, fnSetNTabSelected] = useState(0)
  const [bIsConfirmCloseModalOpen, fnSetBIsConfirmCloseModalOpen] = useState(false)
  const [bIsConfirmChangeTabModalOpen, fnSetBIsConfirmChangeTabModalOpen] =
    useState(false)
  const [nCurrentTabSelected, fnSetNCurrentTabSelected] = useState(0)
  const [bIsDirtyForm, fnSetBIsDirtyForm] = useState(false)
  useState(false)
  const [bIsCommentError, fnSetBIsCommentError] = useState(true)

  const [fnCheckRegister, bIsOpenErrorModal, bLoadingRegister] = useCheckSubmitRegister()

  useEffect(() => {
    if (oAllFieldsRes?.loading || !bIsOpen) return
    ;(async () => {
      if (!aAllFields?.length) await fnGetFields()
      if (!bIsEdit) {
        //add fields for activity creating
        const aFormatedAcitivyFields = oCurrentBoard?.board_model?.fields

        fnSetAActivityFields(aFormatedAcitivyFields)
        return
      }
      //add fields for activity form editing
      
      // const aFormatedAcitivyFields = aAllFields?.map((oField) => {
      //     const bFieldHasValue = oCurrentActivity?.values?.find(
      //       (oFieldValue) => oFieldValue?.opfv_opfd_nid === oField?.opfd_nid,
      //     )
      //     console.log("==> ",bFieldHasValue)
      //     if (bFieldHasValue) {
      //       return {
      //         ...oField,
      //         opfv_brequired: bFieldHasValue.opfv_brequired,
      //         opfv_nposition: bFieldHasValue.opfv_nposition,
      //         ombf_bautofill: bFieldHasValue.ombf_bautofill || null,
      //         opfv_cvalue: bFieldHasValue.opfv_cvalue || null,
      //         selected_option: bFieldHasValue.selected_option || null,
      //       }
      //     }

      //     return null
      //   })
      //   .filter(Boolean)

      const nAllFieldsTotal = (aAllFields?.length + 1) || 0

      let formatedFieldsEdition = aAllFields.map((field, index) => {
        const modelField = oCurrentBoard?.board_model?.fields.find(
          (model) => field.opfd_nid === model.ombf_opfd_nid,
        )
        if (modelField) {
          return {
            ...field,
            ...field?.field,
            ombf_brequired: modelField.ombf_brequired || "NOT_REQUIRED",
            ombf_nposition: modelField.ombf_nposition,
            ombf_bautofill: modelField.ombf_bautofill || null,
            opfv_cvalue: modelField.opfv_cvalue || null,
            selected_option: field.selected_option,
          }
        }

        // add fields that are not in the board model but have values
        const oFieldValue = oCurrentActivity?.values.find(v => v.opfv_opfd_nid === field.opfd_nid)
        const aExcludFieldSlugValue = ['data_de_conclusao', 'data_de_criacao']
        if (
          oFieldValue &&
          !aExcludFieldSlugValue.includes(field?.opfd_cslug) &&
          (oFieldValue?.opfv_cvalue || oFieldValue?.selected_option)
        ) {
          return {
            ...field,
            ...field?.field,
            ombf_nposition: nAllFieldsTotal + (oFieldValue?.opfv_nposition || index),
          }
        }

        return null
      }).filter(Boolean)
      formatedFieldsEdition.sort((a, b) => a.ombf_nposition - b.ombf_nposition)
      fnSetAActivityFields(formatedFieldsEdition)
    })()
  }, [oCurrentActivity, bIsEdit, bIsOpen, oUpdateBoardModelRes, oCurrentBoard])

  const aAcitivyFieldsWithValues = bIsEdit
    ? aAcitivyFields?.map((f, i) => {
        return {
          ...f?.field,
          ...f,
          ombf_bautofill: f.ombf_bautofill || null,
          ombf_nposition: f.ombf_nposition || i,
          selected_option: f.selected_option || null,
          values: oCurrentActivity?.values,
        }
      })
    : aAcitivyFields

  useEffect(() => {
    const uniqueValues = []
    const duplicateIds = []
    if (bIsEdit) {
      fnSetAAcitivyFieldsFormated(aAcitivyFieldsWithValues)
      return
    }
    let aFormatedFields = aAcitivyFieldsWithValues.map((field, i) => {
      return {
        ...field,
        ...field?.field,
        opfd_cname: field?.field?.opfd_cname
          ? field?.field?.opfd_cname
          : field?.opfd_cname,
        opfd_cslug: field?.field?.opfd_cslug
          ? field?.field?.opfd_cslug
          : field?.opfd_cslug,
        opfd_csuffix: field?.field?.opfd_csuffix
          ? field?.field?.opfd_csuffix
          : field?.opfd_csuffix,
        opfd_cprefix: field?.field?.opfd_cprefix
          ? field?.field?.opfd_cprefix
          : field?.opfd_cprefix,
        opfd_nprecision: field?.field?.opfd_nprecision
          ? field?.field?.opfd_nprecision
          : field?.opfd_nprecision,
        opfd_ctype: field?.field?.opfd_ctype
          ? field?.field?.opfd_ctype
          : field?.opfd_ctype,
        options: field?.field?.options ? field?.field?.options : field?.options,
        ombf_bautofill: field?.ombf_bautofill || false,
        //ombf_brequired: field?.field?.ombf_brequired || "NOT_REQUIRED",
        ombf_ddeleted: field?.ombf_ddeleted || null,
        ombf_nid: field?.ombf_nid ? field?.ombf_nid : field?.opfd_nid,
        ombf_nposition: field?.ombf_nposition || null,
        ombf_opfd_nid: field?.ombf_opfd_nid || field?.opfd_nid,
        selected_option: field?.selected_option || null,
        ombf_opmb_nid: field?.ombf_opmb_nid,
        opfd_bis_default: field?.field?.opfd_bis_default
          ? field?.field?.opfd_bis_default
          : field?.opfd_bis_default,
      }
    })

    aFormatedFields.map((field, index) => {
      const id = field.opfd_cslug
      if (!duplicateIds.includes(id)) {
        uniqueValues.push(field)
        duplicateIds.push(id)
      }
      duplicateIds.push(id)
    })
    fnSetAAcitivyFieldsFormated(uniqueValues)
  }, [aAcitivyFields])

  const useFormMethods = useForm({
    resolver: bIsOpen
      ? yupResolver(
          fnCreateFieldsValitionSchema(
            aActivityFieldsFormated,
            bIsEdit,
            cUserTimeZone,
            bCurrentStatus,
            aAllFields
          ),
        )
      : undefined,
  })

  const {
    handleSubmit,
    reset,
    watch,
    formState: { errors, isDirty },
  } = useFormMethods

  useEffect(() => {
    if (!bIsOpen) return

    const aFormatedComments =
      aCommentsList?.length > 0
        ? aCommentsList.map((comment) => {
            return {
              opae_cvalue: comment.opacm_ccontent,
              cUserName: comment.user?.user_cname,
              dDate: comment.opacm_dcreated,
              nUserId: comment.user?.user_nid,
              nCommentId: comment.opacm_nid,
            }
          })
        : []

    fnSetAComments(aFormatedComments)
  }, [aCommentsList, bIsOpen])
  useEffect(() => {
    reset({})
    fnSetNTabSelected(0)
  }, [bIsOpen])

  useEffect(() => {
    if (!bIsEdit || !bIsOpen || !oCurrentActivity) return
    reset({})

    const responsibles = oCurrentActivity?.responsibles?.map(
      (oResponsible) => oResponsible?.user_nid,
    )
    const involveds = oCurrentActivity?.involveds?.map((oInvolved) => oInvolved?.user_nid)

    reset({
      ...oCurrentActivity,
      responsibles,
      involveds,
    })
  }, [bIsEdit, bIsOpen, oCurrentActivity])

  useEffect(
    (e) => {
      if (bIsOpen && bIsOpenErrorModal) fnCancelCriation(e)
    },
    [bIsOpen, bIsOpenErrorModal],
  )

  if (!bIsOpen) return null

  function fnHandleOnSelectTab(nTab) {
    if (isDirty || bIsDirtyForm) {
      fnSetBIsDirtyForm(isDirty)
      fnSetNTabSelected(nTab)
      fnSetBIsConfirmChangeTabModalOpen(true)
      return !bIsDirtyForm
    }
    reset({ ...watch() })
    fnSetNTabSelected(nTab)
    fnSetNCurrentTabSelected(nTab)
  }

  function fnCancelCriation(e) {
    if (!isDirty || bIsOpenErrorModal) {
      fnCloseAndCancelCreation(e)
      return
    }

    fnSetBIsConfirmCloseModalOpen(true)
  }
  function fnCloseAndCancelCreation(e) {
    fnSetAActivityFields([])
    fnOnClose?.(e)
    fnSetOCurrentActivity(null)
    fnSetAComments([])
  }

  async function fnCheckBlockAndBoard() {
    const oCheckRegister = {
      nBlockId: oCurrentBlock?.opbl_nid,
      nBoardId: oCurrentBoard?.id,
      nPanelId: oCurrentPanel?.id,
    }

    const cErrorMessage = bIsEdit
      ? intl.get("BlocksPage.update_activity_error")
      : intl.get("BlocksPage.create_activity_error")
    return await fnCheckRegister(oCheckRegister, cErrorMessage)
  }

  async function fnSubmitActivity(oData) {
   
    const bCanSubmit = await fnCheckBlockAndBoard()
    if (!bCanSubmit) return
    const oPayload = { ...oData }
    oPayload.fields = fnGetDinamycFields(
      oPayload,
      aActivityFieldsFormated,
      cUserTimeZone,
      bIsEdit,
    )
    if (!oPayload?.arr_nfields_to_delete?.length) oPayload.arr_nfields_to_delete = []
    fnSetOparams({ bAppendActivities: true })
    if (!bIsEdit) {
      
      await fnCreateActivity?.(oCurrentBlock?.opbl_nid, oPayload)
      return
    }
    delete oPayload?.values
    await fnUpdateActivity?.(oPayload)
  }

  async function fnHandleSubmitEvidence(oData) {
    const bCanSubmit = await fnCheckBlockAndBoard()
    if (!bCanSubmit) return

    return await fnSubmitEvidence(oData)
  }

  function fnValidateComment(data) {
    if (!data) return true
    const contentWithoutSpaces = data.replace(/\s/g, "")
    return contentWithoutSpaces.length >= 2
  }
  function fnHandleOpenCustomFields(oCurrentBlock) {
    if (isDirty || bIsDirtyForm) {
      fnSetBIsDirtyForm(isDirty)
      fnSetNTabSelected(4)
      fnSetBIsConfirmChangeTabModalOpen(true)
      return !bIsDirtyForm
    }
    fnSetBopenCustomFields(oCurrentBlock)
    reset({ ...watch() })
  }
  async function fnHandleSubmitComment(oData) {
    const bIsCommentIsValid = fnValidateComment(oData.opacm_ccontent)
    const bCanSubmit = await fnCheckBlockAndBoard()
    if (!bCanSubmit || !bIsCommentIsValid) {
      fnSetBIsCommentError(bIsCommentIsValid)
      return
    }

    fnSetBIsCommentError(bIsCommentIsValid)
    return await fnSubmitComment(oData)
  }

  const oTitleField = aAcitivyFields?.find((oField) => oField?.opfd_cslug === cTitleSlug)

  const oTitleValue = oCurrentActivity?.values?.find(
    (v) => v?.opfv_opfd_nid === oTitleField?.opfd_nid,
  )

  const cTitle = bIsEdit
    ? intl.get("BlocksPage.edit_activity_name", {
        activity: oTitleValue?.opfv_cvalue,
      })
    : intl.get("BlocksPage.new_activity")

  const bSubmitActivityLoading = oActivityRes.loading || bLoadingRegister

  const [nActivityId, fnSetCActivityId] = useState("")

  useEffect(() => {
    if (bIsEdit) {
      fnSetCActivityId(oCurrentActivity?.opat_nid)
    }
  }, [oCurrentActivity, bIsEdit])

  return (
    <>
      <Modal isOpen={bIsOpen} size={"lg"} onRequestClose={fnOnClose} nOverlayZindex={2}>
        <Modal.Header onClose={(e) => fnCancelCriation(e)}>{cTitle}</Modal.Header>
        <Modal.Content>
          <div className={styles.container} id="modalContentContainer">
              <RcmpAlert cType="error" bIsOpen={oSubmitEvidence?.error}>
                {intl.get("ActivityEvidence.evidence_error")}
              </RcmpAlert>
              <Tabs
                onSelect={fnHandleOnSelectTab}
                defaultIndex={0}
                selectedIndex={nCurrentTabSelected}
              >
                <Tabs.TabList className={styles.tabs}>
                  <Tabs.Tab>
                    <EditIcon width="16px" height="16px" /> {intl.get("BlocksPage.edit")}
                  </Tabs.Tab>
                  <Tabs.Tab disabled={!bIsEdit}>
                    <ClipIcon /> {intl.get("BlocksPage.evidences")}
                  </Tabs.Tab>
                  <Tabs.Tab disabled={!bIsEdit}>
                    <CommnetDotsIcon /> {intl.get("BlocksPage.comments")}
                  </Tabs.Tab>
                  <Tabs.Tab disabled={!bIsEdit}>
                    <ClockRotateIcon /> {intl.get("BlocksPage.history")}
                  </Tabs.Tab>
                </Tabs.TabList>
                <Tabs.TabPanel>
                  <FormProvider {...useFormMethods}>
                    <form id="activity-form" onSubmit={handleSubmit(fnSubmitActivity)}>
                      <RcmpEditActivity
                        fnOpenModalMoveActivity={fnOpenModalMoveActivity}
                        bIsEdit={bIsEdit}
                        oCurrentActivity={bIsEdit ? oCurrentActivity : null}
                        oActivityFields={aActivityFieldsFormated}
                        fnSetBIsDeleteActivity={fnSetBIsDeleteActivity}
                        fnSetCurrentStatus={fnSetCurrentStatus}
                        fnSetBopenCustomFields={fnHandleOpenCustomFields}
                        bCanChange={bCanChange}
                        bReadOnly={bReadOnly}
                        fnSetAActivityFields={fnSetAActivityFields}
                        nActivityId={nActivityId}
                        bIsAutomationList={bIsAutomationList}
                      />
                    </form>
                  </FormProvider>
                </Tabs.TabPanel>
                <Tabs.TabPanel>
                  <RcmpActivityEvidence
                    fnSetBOpenModalMediaCapture={fnSetBOpenModalMediaCapture}
                    fnSetBOpenModalVideoCapture={fnSetBOpenModalVideoCapture}
                    fnSubmitEvidence={fnHandleSubmitEvidence}
                    oCurrentActivity={oCurrentActivity}
                    aEvidences={aEvidences}
                    fnSetAEvidences={fnSetAEvidences}
                    bReadOnly={bReadOnly}
                    fnEditEvidenceSubmit={fnEditEvidenceSubmit}
                    fnSetIsDirty={(bIsDirty) => fnSetBIsDirtyForm(bIsDirty)}
                  />
                </Tabs.TabPanel>
                <Tabs.TabPanel>
                  <RcmpActivityComments
                    bCanChange={bCanChange}
                    fnSubmitComment={fnHandleSubmitComment}
                    fnDeleteComment={fnDeleteComment}
                    oCreateCommentRes={oCreateCommentRes}
                    fnSubmitUpdateComment={fnSubmitUpdateComment}
                    fnSetAComments={fnSetAComments}
                    aComments={aComments}
                    bReadOnly={bReadOnly}
                    fnSetIsDirty={(bIsDirty) => fnSetBIsDirtyForm(bIsDirty)}
                    bIsCommentError={bIsCommentError}
                    fnSetBIsCommentError={fnSetBIsCommentError}
                  />
                </Tabs.TabPanel>
                <Tabs.TabPanel>
                  <RcmpActivityHistory oCurrentActivity={oCurrentActivity} />
                </Tabs.TabPanel>
              </Tabs>
          </div>
        </Modal.Content>
        <Modal.Footer className={styles.modalFooter}>
          {nTabSelected === 0 && !bReadOnly && (
            <>
              <Button
                variant="outline"
                type="button"
                onClick={(e) => fnCancelCriation(e)}
                disabled={bSubmitActivityLoading}
              >
                {intl.get("cancel")}
              </Button>
              <Button
                variant="primary"
                type="submit"
                form="activity-form"
                isLoading={bSubmitActivityLoading}
              >
                {bIsEdit
                  ? intl.get("save_changes")
                  : intl.get("BlocksPage.create_activity")}
              </Button>
            </>
          )}
        </Modal.Footer>
      </Modal>
      <RcmpModalInfo
        fnHandleCancel={() => fnSetBIsConfirmCloseModalOpen(false)}
        bIsOpen={bIsConfirmCloseModalOpen}
        title={intl.get("cancel")}
        buttonCancelText={intl.get("activityModelModal.close_when_change_field_cancel")}
        buttonSaveText={intl.get("activityModelModal.close_when_change_field_sure")}
        description={
          <p>
            <strong>{intl.get("activityModelModal.close_when_change_fieldA")}</strong>
            {intl.get("activityModelModal.close_when_change_fieldB")}
          </p>
        }
        fnHandleConfirm={() => {
          fnSetBIsConfirmCloseModalOpen(false)
          fnCloseAndCancelCreation()
        }}
        size
      />
      <RcmpModalInfo
        fnHandleCancel={() => {
          fnSetBIsConfirmChangeTabModalOpen(false)
          fnSetNTabSelected(nCurrentTabSelected)
        }}
        bIsOpen={bIsConfirmChangeTabModalOpen}
        title={intl.get("cancel")}
        buttonCancelText={intl.get("activityModelModal.close_when_change_field_cancel")}
        buttonSaveText={intl.get("activityModelModal.close_when_change_field_sure")}
        description={
          <p>
            <strong>{intl.get("activityModelModal.close_when_change_fieldA")}</strong>
            {intl.get("activityModelModal.close_when_change_fieldB")}
          </p>
        }
        fnHandleConfirm={() => {
          reset({}, { keepValues: true })
          fnSetBIsDirtyForm(false)
          if (nTabSelected === 4) {
            fnSetBopenCustomFields(oCurrentBlock)
            fnSetBIsConfirmChangeTabModalOpen(false)
            fnSetNTabSelected(nCurrentTabSelected)
            reset({}, { keepValues: false })
            return
          }
          fnSetBIsConfirmChangeTabModalOpen(false)
          fnSetNCurrentTabSelected(nTabSelected)
        }}
        size="md"
      />
    </>
  )
}
